<ngx-spinner aria-live="polite" aria-relevant="text" aria-atomic="true" size="medium" [type]="loaderIcon" [fullScreen]="true" id="page-loader">
  <p *ngIf="loaderText && showLoaderMessage" class="spinner-page-load-text">
    {{ loaderText }}
  </p>
</ngx-spinner>
